<p-listbox
  [options]="vesselsStore.vm().groupedVessels"
  [group]="true"
  [filter]="true"
  [ngModel]="appStore.selectedVessel()"
  (onChange)="vesselClicked($event.value)"
  filterPlaceHolder="Search Name, Class or Sister Vessel..."
  filterBy="value.name,value.class"
  scrollHeight="19rem"
  class="w-96 bg-transparent"
>
  <ng-template
    let-group
    #group
  >
    <div class="mt-1 flex items-center border-b border-gray-500">
      <span class="vessel-class-name"
        >{{ group.label }} - {{ group.items.length }} vessel{{
          group.items.length > 1 ? 's' : ''
        }}</span
      >
    </div>
  </ng-template>
  <ng-template
    let-item
    #item
  >
    <div class="flex-row items-center gap-2">
      <div class="vessel-name">{{ item.value.name }}</div>
      <div class="vessel-imo text-sm text-gray-400">
        Ship IMO: {{ item.value.imo }}
      </div>
    </div>
  </ng-template>
</p-listbox>
